export const getStateUser = state => state.getUser



// WEBPACK FOOTER //
// ./src/reducers/getstate.js